'use es6';

import PropTypes from 'prop-types';
export default PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]);